import { useState, useEffect } from 'react';
import classNames from 'classnames';

import { Colors } from '@spotahome/ui-library';

import './EnvelopeIllustration.scss';

const EnvelopeAnimation = ({ className = '' }) => {
  const [state, setState] = useState('house');

  useEffect(() => {
    const sequence = async () => {
      await new Promise(resolve => setTimeout(resolve, 800));
      setState('folding');
      await new Promise(resolve => setTimeout(resolve, 600));
      setState('centered');
      await new Promise(resolve => setTimeout(resolve, 400));
      setState('dropping');
      await new Promise(resolve => setTimeout(resolve, 1600));
      setState('resetting');
      await new Promise(resolve => setTimeout(resolve, 50));
      setState('house');
    };

    sequence();
    const interval = setInterval(sequence, 4800);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={classNames('envelope-illustration__container', className)}>
      <svg
        className="envelope-illustration__background-svg"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 500 500"
      >
        <defs>
          <clipPath id="clip0_0_72">
            <rect fill="white" height="500" rx="24" width="500" />
          </clipPath>
        </defs>
        <g clipPath="url(#clip0_0_72)">
          <rect
            fill={Colors['secondary-pink']}
            height="500"
            rx="24"
            width="500"
          />
        </g>
      </svg>

      <div
        className={classNames('envelope-illustration__animation-wrapper', {
          'envelope-illustration__animation-wrapper--clip-dropping':
            state === 'dropping'
        })}
      >
        <div
          className={classNames(
            'envelope-illustration__wrapper',
            `envelope-illustration__wrapper--${state}`
          )}
        >
          <svg
            className="envelope-illustration__body-svg"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 500 500"
          >
            <path
              d="M2.00621e-05 250.809L0 499.809L500 499.809L500 250.809L2.00621e-05 250.809Z"
              fill="#F4EFED"
            />
          </svg>

          <svg
            className={classNames('envelope-illustration__roof-svg', {
              'envelope-illustration__roof-svg--house': state === 'house',
              'envelope-illustration__roof-svg--folding': state === 'folding',
              'envelope-illustration__roof-svg--folded':
                state !== 'house' && state !== 'folding'
            })}
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 500 500"
          >
            <path
              d="M250 -0.191412L2.55447e-05 250.809L500 250.809L250 -0.191412Z"
              fill={Colors.interaction}
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default EnvelopeAnimation;
